import { Button, Grid2, Stack, Typography } from "@mui/material";
import ContainerLoading from "../components/ContainerLoading";
import { IconTicket } from "@tabler/icons-react";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import CouponsTableComponent from "../components/CouponsTableComponent";
import { couponsList } from "../services/coupons";
import CouponsRegister from "../components/CouponsRegister";
import PageHeader from "../components/PageHeader";

const Coupons = () => {
  const [open, setOpen] = useState(false);

  const {
    data,
    isLoading,
    isFetching,
    refetch,
  }: {
    data: Array<{
      id: string;
      code: string;
      cuponsUser: number;
      limit: number;
      discount: number;
      discountType: string;
      validate: Date;
      type: string;
      firstMonthlyPayment: boolean;
      statusCupom: string;
    }>;
    isLoading: boolean;
    isFetching: boolean;
    refetch: () => void;
  } = useQuery({
    queryKey: ["couponsList"],
    queryFn: async () => await couponsList({}),
    initialData: [],
  });

  const refetchAll = () => {
    refetch();
  };

  const loading = isLoading || isFetching;

  return (
    <ContainerLoading loading={loading}>
      <Grid2 container spacing={2} padding={2}>
        <PageHeader
          title="Cupons"
          subtitle="Informações gerais dos cupons."
          options={
            <Stack
              sx={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: { xs: "flex-start", lg: "flex-end" },
                gap: 2,
              }}
            >
              <Button
                variant="contained"
                sx={{ gap: 0.5 }}
                onClick={() => setOpen(true)}
              >
                <IconTicket size={18} />
                <Typography variant="body2">Criar cupom</Typography>
              </Button>
            </Stack>
          }
        />

        <Grid2 size={12}>
          <Grid2 container spacing={2}>
            <Grid2 size={12}>
              <CouponsTableComponent data={data} refetch={() => refetchAll()} />
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
      {open && (
        <CouponsRegister
          open={open}
          onClose={() => setOpen(false)}
          refetch={() => refetchAll()}
        />
      )}
    </ContainerLoading>
  );
};

export default Coupons;
